module.exports = __webpack_public_path__ + "static/media/Live_Quiz_Banner_v2.b13c0bd0.png";